// extracted by mini-css-extract-plugin
export default {"container":"signature_container__9JpXH","footer":"signature_footer__3z+5H"};